const changeHtmlLang = (lang) => {
  const html = document.documentElement;
  html.setAttribute('lang', lang);
};

export default changeHtmlLang;
